import _extends from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/extends";
import _slicedToArray from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  margin: 0 8px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  background-color: ", ";\n  border: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  z-index: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  min-width: 480px;\n  max-width: 600px;\n  width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { format, isValid } from 'date-fns/fp';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { DateRangePicker } from '../date/DateRangePicker';
import { Icon } from '../icon/Icon';
import { Input } from './Input';
import { themeGet } from '@styled-system/theme-get';
var Wrapper = styled.div(_templateObject());
var DateRangeInputWrapper = styled.div(_templateObject2());
var DateRangePickerWrapper = styled.div(_templateObject3(), themeGet('dateRangeInput.backgroundColor'), themeGet('dateRangeInput.border'), themeGet('dateInput.borderRadius'), themeGet('dateRangeInput.boxShadow'), themeGet('dateRangeInput.zIndex'));
var Divider = styled.div(_templateObject4());

var Popover = function Popover(_ref) {
  var children = _ref.children,
      visible = _ref.visible,
      onClose = _ref.onClose;
  var popoverRef = useRef(null);
  var handleBackDropClick = useCallback(function (event) {
    if (popoverRef.current && !popoverRef.current.contains(event.target)) {
      onClose(event);
    }
  }, [onClose]);
  useEffect(function () {
    document.addEventListener('mousedown', handleBackDropClick);
    return function () {
      document.removeEventListener('mousedown', handleBackDropClick);
    };
  }, [handleBackDropClick]);
  return (
    /*#__PURE__*/
    React.createElement("div", {
      ref: popoverRef
    }, visible && children)
  );
};

export var DateRangeInput = function DateRangeInput(_ref2) {
  var value = _ref2.value,
      onChange = _ref2.onChange,
      disabled = _ref2.disabled,
      defaultValue = _ref2.defaultValue,
      dateFormat = _ref2.dateFormat,
      maxDate = _ref2.maxDate,
      minDate = _ref2.minDate,
      restProps = _objectWithoutProperties(_ref2, ["value", "onChange", "disabled", "defaultValue", "dateFormat", "maxDate", "minDate"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = useState(value || defaultValue),
      _useState4 = _slicedToArray(_useState3, 2),
      currentValue = _useState4[0],
      setCurrentValue = _useState4[1];

  var _currentValue$map = currentValue.map(function (date) {
    return isValid(date) ? format(dateFormat, date) : '';
  }),
      _currentValue$map2 = _slicedToArray(_currentValue$map, 2),
      from = _currentValue$map2[0],
      to = _currentValue$map2[1];

  var handleChange = useCallback(function (event) {
    if (onChange) {
      onChange(event);
    }

    if (value === undefined) {
      setCurrentValue(event.target.value);
    }
  }, [onChange, setCurrentValue, value]);
  useEffect(function () {
    if (Array.isArray(value) && value !== currentValue) {
      setCurrentValue(value);
    }
  }, [currentValue, value]);
  return (
    /*#__PURE__*/
    React.createElement(Wrapper, null,
    /*#__PURE__*/
    React.createElement(DateRangeInputWrapper, null,
    /*#__PURE__*/
    React.createElement(Input, _extends({}, restProps, {
      value: from,
      onFocus: useCallback(function () {
        return !disabled && setVisible(true);
      }, [disabled]),
      placeholder: dateFormat,
      suffix:
      /*#__PURE__*/
      React.createElement(Icon, {
        name: "CALENDAR"
      }),
      disabled: disabled,
      readOnly: true
    })),
    /*#__PURE__*/
    React.createElement(Divider, null,
    /*#__PURE__*/
    React.createElement(Icon, {
      name: "ARROW_RIGHT"
    })),
    /*#__PURE__*/
    React.createElement(Input, _extends({}, restProps, {
      value: to,
      onFocus: useCallback(function () {
        return !disabled && setVisible(true);
      }, [disabled]),
      placeholder: dateFormat,
      suffix:
      /*#__PURE__*/
      React.createElement(Icon, {
        name: "CALENDAR"
      }),
      disabled: disabled,
      readOnly: true
    }))),
    /*#__PURE__*/
    React.createElement(Popover, {
      visible: visible,
      onClose: useCallback(function () {
        return setVisible(false);
      }, [])
    },
    /*#__PURE__*/
    React.createElement(DateRangePickerWrapper, null,
    /*#__PURE__*/
    React.createElement(DateRangePicker, {
      onChange: handleChange,
      maxDate: maxDate,
      minDate: minDate
    }))))
  );
};
DateRangeInput.defaultProps = {
  defaultValue: [null, null],
  dateFormat: 'yyyy-MM-dd'
};